export default "__VITE_ASSET__DIJbuZT$__"